/* eslint-disable */
import axios from 'axios';
import { API } from '../../config/api/index';
import { appDataFetchBegin, appDataFetchErr, appDataFetchSuccess } from './actions';

export const appDataFetch = () => {
  return async (dispatch) => {
    dispatch(appDataFetchBegin());
    try {
      const response = await axios.get(`${API.get_app_data}`);
      dispatch(appDataFetchSuccess(response.data));
    } catch (err) {
      console.error("Error:", err);
      dispatch(appDataFetchErr(err));
    }
  };
};
